const esLa = {
  Activá: 'Activa',
  acá: 'aquí',
  Agregá: 'Agrega',
  Ahorrá: 'Ahorra',
  Asigná: 'Asigna',
  asigná: 'asigna',
  Completá: 'Completa',
  comunicate: 'comunícate',
  configurá: 'configura',
  contactá: 'contacta',
  contás: 'cuentas',
  copiá: 'copia',
  Creá: 'Crea',
  Debés: 'Debes',
  debés: 'debes',
  Descargá: 'Descarga',
  descartá: 'descarta',
  desconocés: 'desconoces',
  Deseás: 'Deseas',
  Elegí: 'Elige',
  eliminará: 'eliminara',
  empezá: 'empieza',
  Empezá: 'Empieza',
  Establecé: 'Establece',
  guardá: 'guarda',
  Guardá: 'guarda',
  Ingresá: 'Ingresa',
  ingresá: 'ingresa',
  Imprimí: 'Imprime',
  Iniciá: 'Inicia',
  Intentá: 'Intenta',
  Invitá: 'Invita',
  Cerrá: 'Cierra',
  Pedile: 'Pídele',
  Probá: 'Prueba',
  Usá: 'Usa',
  elegís: 'eliges',
  pedile: 'pídele',
  intentá: 'intenta',
  sos: 'eres',
  '¿No sos vos?': '¿No eres tú?',
  'Modificada por vos': 'Modificada por ti',
  'Modificado por vos': 'Modificado por ti',
  Hablá: 'Habla',
  acabás: 'acabas',
  Mirá: 'Mira',
  Mostralo: 'Muéstralo',
  necesitás: 'necesitas',
  Podés: 'Puedes',
  podés: 'puedes',
  potenciá: 'potencia',
  Querés: 'Quieres',
  querés: 'quieres',
  quitá: 'quita',
  Recordá: 'Recuerda',
  Revisá: 'Revisa',
  sabés: 'sabes',
  Seleccioná: 'Selecciona',
  Subí: 'Sube',
  Sos: 'Eres',
  Sumá: 'Suma',
  Tenés: 'Tienes',
  tenés: 'tienes',
  Verificá: 'Verifica',
  verificá: 'verifica',
  Tené: 'Ten',
  Adjuntá: 'adjunta',
  modificá: 'modifica',
  Estás: 'Está',
  Vos: 'Tú',
  generará: 'generara',
  será: 'sera',
  Corregí: 'Corrige',
  volvé: 'vuelve',
} as const;

export default esLa;
